import { useRef, useState } from "react";
import ModalBuyPremium from "./buy-premium/components/modals/ModalBuyPremium.tsx";
import BuyPremiumBanner from "./buy-premium/components/BuyPremiumBanner.tsx";
import IconChevron from "@/assets/icons/chevron.svg?react";
import IconEdit from "@/assets/icons/edit.svg?react";
import IconDiamondCircleLinear from "@/assets/icons/diamond-circle-linear.svg?react";
import IconLanguageLinear from "@/assets/icons/language-linear.svg?react";
import IconCreditCard from "@/assets/icons/credit-card.svg?react";
import { RELEASE_P2P } from "@/config/launch.config";
import IconTelegramLinear from "@/assets/icons/telegram-linear.svg?react";
import IconInstagramLinear from "@/assets/icons/instagram-linear.svg?react";
import IconFacebookLinear from "@/assets/icons/facebook-linear.svg?react";
import IconTwitterLinear from "@/assets/icons/twitter-linear.svg?react";
import NewsIcon from "@/assets/icons/news.svg?react";
import IconInfoCircleLinear from "@/assets/icons/info-circle-linear.svg?react";
import HistoryIcon from "@/assets/icons/history.svg?react";
import IconExternalLink from "@/assets/icons/external-link.svg?react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import PageWrapper from "../../components/PageWrapper.tsx";
import { useGetProfile } from "@/pages/profile/api";
import {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer.tsx";
import BaseButton from "@/components/base/button/BaseButton.tsx";

import IconClose from "@/assets/icons/close.svg?react";
import { useFetchSettings, useStoryDetail } from "@/pages/home/api";
import UserIcon from "@/assets/icons/user-circle.svg?react";

import { openLink } from "@telegram-apps/sdk-react";
import StoriesComponent, {
  type StoriesModalRef,
} from "@/components/stories/StoriesModal.tsx";
import { appConfig } from "@/lib/site-config.ts";

import VibratingButton from "@/components/base/button/VibratingButton.tsx";

import { openPublicOffer } from "@/shared/utils/common.ts";
import Image from "@/components/base/Image.tsx";
export default function ProfilePage() {
  const { t, i18n } = useTranslation();
  const { data: settings, isLoading: isSettingsLoading } = useFetchSettings();
  const navigate = useNavigate();
  const { data: storyData, isLoading: isStoryLoading } = useStoryDetail(
    appConfig.storySlug.aboutProject
  );

  const storiesModal = useRef<StoriesModalRef>(null);

  const showStories = () => {
    if (storiesModal.current) {
      storiesModal.current.openStories(0);
    }
  };

  const [isOpen, setIsOpen] = useState(false);

  const { data: profile } = useGetProfile();

  const languageList = [
    {
      title: "O'zbekcha",
      icon: "images/flags/uz.svg",
      key: "uz",
    },
    {
      title: "English",
      icon: "images/flags/en.svg",
      key: "en",
    },
    {
      title: "Русский",
      icon: "images/flags/ru.svg",
      key: "ru",
    },
  ];
  const [language, setLanguage] = useState(i18n.language);

  const socials = [
    // {
    //   title: t("app_language"),
    //   icon: <IconLanguageLinear width="24" height="24" className="shrink-0" />,
    //   detail: (
    //     <div className="flex-y-center gap-1">
    //       <span className="text-sm text-gray-1 leading-130">
    //         {languageList.find((item) => item.key === language)?.title}
    //       </span>
    //       <IconChevron className="w-5 h-5 text-gray-1" strokeWidth="1.5" />
    //     </div>
    //   ),
    //   action: () => {
    //     setOpenDrawer(true);
    //   },
    //   visible: true,
    // },
    {
      title: t("telegram_channel"),
      icon: <IconTelegramLinear width="24" height="24" className="shrink-0" />,
      detail: <IconExternalLink className="w-5 h-5 text-gray-1" />,
      action: () =>
        openLink(settings?.telegram_channel_link ?? "", {
          tryInstantView: false,
        }),
      visible: !!settings?.telegram_channel_link,
    },
    {
      title: t("instagram_channel"),
      icon: <IconInstagramLinear width="24" height="24" className="shrink-0" />,
      detail: <IconExternalLink className="w-5 h-5 text-gray-1" />,
      action: () =>
        openLink(settings?.instagram_link ?? "", {
          tryInstantView: false,
        }),
      visible: !!settings?.instagram_link,
    },
    {
      title: t("facebook_channel"),
      icon: <IconFacebookLinear width="24" height="24" className="shrink-0" />,
      detail: <IconExternalLink className="w-5 h-5 text-gray-1" />,
      action: () =>
        openLink(settings?.facebook_link ?? "", {
          tryInstantView: false,
        }),
      visible: !!settings?.facebook_link,
    },
    {
      title: t("twitter_channel"),
      icon: <IconTwitterLinear width="24" height="24" className="shrink-0" />,
      detail: <IconExternalLink className="w-5 h-5 text-gray-1" />,
      action: () =>
        openLink(settings?.twitter_link ?? "", {
          tryInstantView: false,
        }),
      visible: !!settings?.twitter_link,
    },
    // {
    //   title: t("about_project"),
    //   icon: (
    //     <IconInfoCircleLinear width="24" height="24" className="shrink-0" />
    //   ),
    //   action: () => {
    //     showStories();
    //   },
    //   detail: (
    //     <div className="flex-y-center gap-1 shrink-0">
    //       <span className="text-sm text-gray-1 leading-130">v 1.0.0</span>
    //       <IconChevron className="w-5 h-5 text-gray-1" strokeWidth="1.5" />
    //     </div>
    //   ),
    //   visible: true,
    // },
  ];

  const [openDrawer, setOpenDrawer] = useState(false);

  async function changeLocale(lang: string) {
    await i18n.changeLanguage(lang);
    // await queryClient.invalidateQueries({
    //   queryKey: [TranslationKey.Translations, lang],
    // });
    setOpenDrawer(false);
    window.location.reload();
  }

  return (
    <PageWrapper backPath="/">
      {storyData && !isStoryLoading && (
        <StoriesComponent ref={storiesModal} storiesData={[storyData]} />
      )}
      <div className="pt-4 pb-5 rounded-b-2xl border-b border-white/08 bg-[linear-gradient(180deg,_rgba(33,33,38,0)_0%,_rgba(33,33,38,0.4)_100%)] flex flex-col items-center mb-4 relative">
        <div
          className={`w-[88px] h-[88px] p-0.5 rounded-full mb-4 ${
            profile?.is_premium
              ? "bg-yellow-linear shadow-[0_8.44px_32.21px_0_rgba(251,199,108,0.30)]"
              : "bg-white/08"
          }`}
        >
          <div className="p-1 rounded-full bg-dark w-[84px] h-[84px] flex-center">
            {profile?.avatar ? (
              <Image
                imgClassName="object-cover w-[76px] h-[76px]"
                urls={profile?.avatar}
                size="small"
                wrapperClassName="rounded-full"
                alt="Avatar"
              />
            ) : (
              <UserIcon className="size-11 text-gray-1" />
            )}
          </div>
        </div>
        <h1 className="text-xl font-semibold leading-5 text-white mb-1.5 flex-y-center gap-2">
          {" "}
          {profile?.full_name}{" "}
          {profile?.is_premium && (
            <IconDiamondCircleLinear className="w-6 h-6 shrink-0" />
          )}{" "}
        </h1>
        <p className="text-sm text-gray-1 leading-130 font-normal">
          {profile?.username && `@${profile.username}`}
        </p>
        <VibratingButton
          onClick={() => navigate(`/profile/edit`)}
          className="absolute left-4 top-4"
        >
          <IconEdit className="w-6 h-6 text-white" />
        </VibratingButton>
      </div>
      <div className="container space-y-4">
        {!profile?.is_premium && (
          <BuyPremiumBanner
            description="more_opportunities_than_ever_before"
            onClick={() => navigate("/profile/premium")}
          >
            <div className="rounded-full w-8 h-8 bg-dark/20 relative z-10 backdrop-blur-[10px] flex-center">
              <IconChevron
                strokeWidth="2"
                color="white"
                width="20"
                height="20"
              />
            </div>
          </BuyPremiumBanner>
        )}
        <div className="flex flex-col gap-4">
          <div className="flex flex-col rounded-xl bg-white/08 border-b border-white/08 overflow-hidden">
            {/* Transactions */}
            <VibratingButton
              className="flex-y-center gap-3 p-3 relative group active:bg-white/08 transition-200 cursor-pointer text-start"
              onClick={() => navigate("/history")}
            >
              <HistoryIcon className="shrink-0 text-orange-100 size-6" />
              <p className="w-full text-sm font-semibold leading-130 text-white">
                {t("transactions")}
              </p>
              <div className="flex-y-center gap-1">
                {/* TODO: Add real data */}
                {/* <span className="text-xs text-white bg-red rounded-full font-medium min-w-[24px] flex-center leading-130 px-1 py-0.5">
                  2
                </span> */}
                <IconChevron
                  className="w-5 h-5 text-gray-1"
                  strokeWidth="1.5"
                />
              </div>
              <hr className="h-px border-none w-full absolute bottom-0 left-12 bg-white/08 group-last:hidden" />
            </VibratingButton>
            {/* My Cards — visible with the P2P/card-binding release */}
            {RELEASE_P2P && (
            <VibratingButton
              className="flex-y-center gap-3 p-3 relative group active:bg-white/08 transition-200 cursor-pointer text-start"
              onClick={() => navigate("/profile/cards")}
              aria-label={t("my_cards") || "Mening kartalarim"}
            >
              <IconCreditCard className="shrink-0 text-orange-100 size-6" />
              <p className="w-full text-sm font-semibold leading-130 text-white">
                {t("my_cards") || "Mening kartalarim"}
              </p>
              <IconChevron className="w-6 h-6 text-gray-1" strokeWidth="1.5" />
              <hr className="h-px border-none w-full absolute bottom-0 left-12 bg-white/08 group-last:hidden" />
            </VibratingButton>
            )}
            {/* Language */}
            <VibratingButton
              className="flex-y-center gap-3 p-3 relative group active:bg-white/08 transition-200 cursor-pointer text-start"
              onClick={() => setOpenDrawer(true)}
            >
              <IconLanguageLinear width="24" height="24" className="shrink-0" />
              <p className="w-full text-sm font-semibold leading-130 text-white">
                {t("app_language")}
              </p>
              <div className="flex-y-center gap-1">
                <span className="text-sm text-gray-1 leading-130">
                  {languageList.find((item) => item.key === language)?.title}
                </span>
                <IconChevron
                  className="w-5 h-5 text-gray-1"
                  strokeWidth="1.5"
                />
              </div>
              <hr className="h-px border-none w-full absolute bottom-0 left-12 bg-white/08 group-last:hidden" />
            </VibratingButton>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col rounded-xl bg-white/08 border-b border-white/08 overflow-hidden">
            {isSettingsLoading
              ? Array.from({ length: 2 }).map((_, idx) => (
                  <div
                    className="w-full skeleton rounded mt-0.5 h-11"
                    key={idx}
                  />
                ))
              : socials
                  .filter((item) => item.visible)
                  .map((child, childIdx) => (
                    <VibratingButton
                      className="flex-y-center gap-3 p-3 relative group active:bg-white/08 transition-200 cursor-pointer text-start"
                      key={childIdx}
                      onClick={() => child.action && child.action()}
                    >
                      {child.icon}
                      <p className="w-full text-sm font-semibold leading-130 text-white">
                        {child.title}
                      </p>
                      {child.detail}
                      <hr className="h-px border-none w-full absolute bottom-0 left-12 bg-white/08 group-last:hidden" />
                    </VibratingButton>
                  ))}
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col rounded-xl bg-white/08 border-b border-white/08 overflow-hidden">
            {/* DON P2P */}
            <VibratingButton
              className="flex-y-center gap-3 p-3 relative group active:bg-white/08 transition-200 text-start"
              onClick={showStories}
            >
              <IconInfoCircleLinear className="shrink-0 text-orange-100 size-[22px]" />
              <p className="w-full text-sm font-semibold leading-130 text-white">
                {t("about_project")}
              </p>
              <div className="flex-y-center gap-1 shrink-0">
                <span className="text-sm text-gray-1 leading-130">v 1.0.0</span>
                <IconChevron
                  className="w-5 h-5 text-gray-1"
                  strokeWidth="1.5"
                />
              </div>
              <hr className="h-px border-none w-full absolute bottom-0 left-12 bg-white/08 group-last:hidden" />
            </VibratingButton>
            {/* Ommaviy offerta */}
            <VibratingButton
              className="flex-y-center gap-3 p-3 relative group active:bg-white/08 transition-200 text-start"
              onClick={() => openPublicOffer({})}
            >
              <NewsIcon className="shrink-0 text-orange-100 size-[22px]" />
              <p className="w-full text-sm font-semibold leading-130 text-white">
                {t("public_offer")}
              </p>
              <div className="flex-y-center gap-1 shrink-0">
                <IconChevron
                  className="w-5 h-5 text-gray-1"
                  strokeWidth="1.5"
                />
              </div>
              <hr className="h-px border-none w-full absolute bottom-0 left-12 bg-white/08 group-last:hidden" />
            </VibratingButton>
          </div>
        </div>
      </div>
      {/*<YandexAd />*/}
      <ModalBuyPremium open={isOpen} onClose={() => setIsOpen(false)} />
      <Drawer open={openDrawer} onOpenChange={(e) => setOpenDrawer(e)}>
        <DrawerContent className="bg-gray-4" showTopThumb>
          <DrawerHeader className="flex justify-between items-center">
            <DrawerTitle className="text-lg" data-testid="title">
              {t("change_language")}
            </DrawerTitle>
            <DrawerClose>
              <IconClose className="size-6 text-gray-1 cursor-pointer" />
            </DrawerClose>
          </DrawerHeader>
          <DrawerBody>
            <div className="flex flex-col justify-center pl-4 -mt-4 -mx-4">
              {languageList.map((item, index) => (
                <VibratingButton
                  vibrationType="selection"
                  className="border-b border-white/08 overflow-hidden pr-4 flex-center-between last-of-type:border-b-0"
                  key={index}
                  onClick={() => setLanguage(item.key)}
                >
                  <div
                    className="flex-y-center gap-3 py-2.5 relative group"
                    key={index}
                  >
                    <div className="w-8 h-8 bg-white/08 rounded-lg flex-center shrink-0">
                      <img
                        className="object-cover w-6 h-6"
                        src={item.icon}
                        alt=""
                      />
                    </div>
                    <p className="w-full text-sm font-semibold leading-130 text-white">
                      {item.title}
                    </p>
                  </div>
                  <div>
                    <input
                      checked={language === item.key}
                      className="w-0 h-0 peer hidden"
                      type="radio"
                      readOnly
                    />
                    <div className="w-6 h-6 rounded-full border border-white/08 peer-checked:bg-blue peer-checked:border-blue transition-200 relative after:absolute after:left-1/2 after:top-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:w-3 after:h-3 after:rounded-full after:bg-white after:duration-200 after:opacity-0 peer-checked:after:opacity-100 peer-checked:after:drop-shadow-[0_0_10px_#00224B]" />
                  </div>
                </VibratingButton>
              ))}
              <div className="pr-4">
                <BaseButton
                  className="w-full mt-4"
                  text={t("save")}
                  onClick={() => changeLocale(language)}
                ></BaseButton>
              </div>
            </div>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </PageWrapper>
  );
}
